import T from 'prop-types';

export default {
  stress: T.array.isRequired,
  userColor: T.string.isRequired,
  isMobile: T.bool.isRequired,
  isDesktop: T.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/shapes/stressChart.js